import { Currency } from "./currencyToSymbolMapper"

export class DecimalPrice {
    readonly value: string
    readonly currency: Currency

    constructor(value: number, currency: Currency) {
        this.currency = currency
        this.value = this.getDecimalValue(value)
    }

    private getDecimalValue(value: number): string {
        const decimals = currencyDecimalMapper[this.currency]
        return (value / Math.pow(10, decimals)).toFixed(decimals)
    }
}
export const currencyDecimalMapper: Record<Currency, number> = {
    EURO: 2,
    euro: 2,
    USD: 2,
    usd: 2,
    POUND: 2,
    pound: 2,
}
